import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditMasterTCO = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Edit Master TCO" }));
  const history = useHistory();
  const [modelGroup, setModelGroup] = useState();
  const [country, setCountry] = useState();
  const [unit, setUnit] = useState();
  const [exRate, setExRate] = useState();
  const [fuelCost, setFuelCost] = useState();
  const [operLaborCost, setOperLaborCost] = useState(); 
  const { user, setUser } = useState; 

  const AlertError = (message) => {
    Swal.fire("Master Country Vat!", message, "error");
  };

  useEffect(() => {
    setModelGroup(props.location.state.row.modelGroup);
    setCountry(props.location.state.row.country);
    setUnit(props.location.state.row.unit);
    setExRate(props.location.state.row.exRate);
    setFuelCost(props.location.state.row.fuelCost);
    setOperLaborCost(props.location.state.row.operLaborCost);

  }, []);

  const onSubmit = async (data) => {
    if (modelGroup === undefined || modelGroup === "") {
      return AlertError("Please insert model group !!");
    }
    if (country === undefined || country === "") {
        return AlertError("Please insert country !!");
      }

    if (unit === undefined || unit === "") {
        return AlertError("Please insert unit !!");
    }

    if (exRate === undefined || exRate === "") {
        return AlertError("Please insert ex rate !!");
    }

    if (fuelCost === undefined || fuelCost === "") {
        return AlertError("Please insert fuel cost !!");
    }

    if (operLaborCost === undefined || operLaborCost === "") {
        return AlertError("Please insert operation labor cost !!");
    }
      
    
      
    var events = {
      modelGroup,
      country,
      unit,
      exRate,
      fuelCost,
      operLaborCost,
    };

    let apiUrls = `${baseURLV1}/dynamic/masterTcos/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Edit !",
          "Your can not update TCO. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Edit Master TCO "></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Model Group" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={modelGroup}
              onChange={(e) => setModelGroup(e.target.value)}
            />
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Country" })}:{" "}
            </p>
            <input
              name="country"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
            </span>
            {intl.formatMessage({ id: "###",defaultMessage:"Unit" })}:{' '}
            </p>
            <input
              name="unit"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={unit}
              onChange={(e) => setUnit(e.target.value)
              }
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Ex Rate" })}:{" "}
            </p>
            <input
              name="exRate"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={exRate}
              onChange={(e) => setExRate(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Fuel Cost" })}:{" "}
            </p>
            <input
              name="fuelCost"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={fuelCost}
              onChange={(e) => setFuelCost(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Operation Labor Cost" })}:{" "}
            </p>
            <input
              name="operLaborCost"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={operLaborCost}
              onChange={(e) => setOperLaborCost(e.target.value)}
            />
          </div>

         
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterTCO">
              <button type="button" className="btn btn-secondary wbt mr-5">
              {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
            {intl.formatMessage({ id: "###",defaultMessage:"Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
